// Global packages and components
import { LinkInner } from '~/components'

// Types
import type { NavItem } from '~/types'

interface NavLinkProps extends NavItem {
  className?: string
  hasArrow?: boolean
  onClick: () => void
  min?: number
  max?: number
  start?: number
  end?: number
}

// Main export
const FilterPrice = ({
  icon,
  title,
  titleBold,
  titleHighlight,
  className,
  hasArrow,
  onClick,
  min,
  max,
  start,
  end,
}: NavLinkProps) => {
  const classes = hasArrow
    ? 'flex justify-between flex-col' + ' ' + className
    : className

  return (
    <button
      onClick={onClick}
      className={classes}
    >
      <LinkInner
        icon={icon}
        title={title}
        titleBold={titleBold}
        titleHighlight={titleHighlight}
        hasArrow={hasArrow}
      />
      {(start !== undefined || min !== undefined) &&
        (end !== undefined || max !== undefined) && (
          <p className="mb-0 pt-1 text-left text-sm font-semibold text-teal-green">
            £{start ?? min} - £{end ?? max}
          </p>
        )}
    </button>
  )
}

export default FilterPrice
